import React from "react";
import { Building2, Landmark, ShieldCheck, ChevronRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const segments = [{
  title: "Municipal",
  description: "Streamline local government operations, from permitting and licensing to public works and citizen services, ensuring efficient community management.",
  icon: Building2,
  link: "#"
}, {
  title: "State",
  description: "Connect multiple agencies and departments with a unified system for statewide resource management, compliance tracking, and inter-agency collaboration.",
  icon: Landmark,
  link: "#"
}, {
  title: "Federal",
  description: "High-security, scalable ERP solutions designed to meet stringent federal compliance, data protection standards, and complex national operational needs.",
  icon: ShieldCheck,
  link: "#"
}];
export default function GovernmentalSegments() {
  return <section id="governmental-segments" className="dark bg-background text-foreground relative py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-[#095fa3] to-[#074b82] pointer-events-none z-0" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col items-center text-center mb-16">
          <Badge variant="secondary" className="bg-[#ecf4fe] text-[#095fa3] hover:bg-[#ecf4fe]/90 border-none mb-6 px-4 py-1 text-sm font-bold tracking-wider uppercase">
            Sectors Served
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-white font-sans tracking-tight max-w-3xl">
            Tailored ERP Solutions for Every Level of Government
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {segments.map((segment, i) => {
          const Icon = segment.icon;
          return <Card key={segment.title} data-index={i} className="bg-white border-[#095fa3] border-2 shadow-xl hover:shadow-2xl transition-all duration-300 flex flex-col h-full group">
                <CardHeader className="pb-4">
                  <div className="w-14 h-14 rounded-xl bg-[#ecf4fe] flex items-center justify-center mb-6 text-[#095fa3] group-hover:scale-110 transition-transform duration-300">
                    <Icon size={28} strokeWidth={2} />
                  </div>
                  <CardTitle className="text-2xl font-bold text-[#3f444b] font-sans">
                    {segment.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <p className="text-[#3f444b] text-base leading-relaxed font-sans">
                    {segment.description}
                  </p>
                </CardContent>
                <CardFooter className="pt-4 pb-8">
                  <Link to={segment.link} className="text-[#095fa3] font-semibold flex items-center gap-1 hover:gap-2 transition-all duration-300">
                    Learn More <ChevronRight size={18} />
                  </Link>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}